"use client";
import styled from "styled-components";
import {usePathname, useRouter, useSearchParams} from "next/navigation";
import {observer} from "mobx-react";
import BrandLogo from "/public/assets/images/logo/logo.png"
import {SIZES} from "@/components/constants";
import {useCallback, useEffect} from "react";
import { LuMenu } from "react-icons/lu";
import {useStore} from "@/store";
import {IoChevronBackSharp} from "react-icons/io5";
import {setScreenHeight} from "@/styles/GlobalStyle";
import {debounce} from "lodash";
import MenuNavigationWrapPc from "@/app/homepage/layouts/components/MenuNavigationWrapPc";
import MenuNavigationWrap from "@/app/homepage/layouts/components/MenuNavigationWrap";
const Header = observer(({ scrollRef, className = "" }) => {
    const router = useRouter();
    const pathname = usePathname();
    const isHomepageRoot = pathname === "/homepage";
    const {navigationStore} = useStore();
    const params = useSearchParams();
    // useEffect(() => {
    //     const menuId = params.get("menu-id");
    //     if (menuId) {
    //         navigationStore.setMenuId(menuId);
    //     }
    // }, [params]);
    const debSetScreenHeight = useCallback(
        debounce(() => {
            setScreenHeight();
        }, 300),
        [],
    );
    useEffect(() => {
        debSetScreenHeight();
        window.addEventListener('resize', debSetScreenHeight);
        return () => window.removeEventListener('resize', debSetScreenHeight);
    }, []);
    return (
        <>
            <HeaderWrap $headActive={typeof navigationStore.openIndex === "number"} className={`${className} site-page-header`}>
                {
                    className === "page" &&
                    <div className={"back-site"}
                        onClick={() => {
                            router.back();
                            navigationStore.setClearNavigation();
                        }}
                    >
                        <IoChevronBackSharp color={"#23203B"} size={20}/>
                    </div>
                }
                <div className={"logo"} onClick={() => {

                    router.push("/homepage");
                }}>
                    <img src={BrandLogo?.src} alt={"로고"}/>
                </div>
                <div className={"header-control-wrap"}>
                    <div
                        className={`${!isHomepageRoot ? "page" : ""} mall-to`}
                        // $headActive={typeof navigationStore.openIndex === "number"}
                        onClick={() => {
                            window.open("https://woongbee.shop/", "_blank", "noopener,noreferrer");
                        }}
                    >
                        <span>쇼핑몰 바로가기</span>
                    </div>
                    <div className={`toggle-btn ${!isHomepageRoot ? "page" : ""}`} onClick={() => {
                        navigationStore.setSideNavigationOpen(!navigationStore.sideNavigationOpen);
                    }}>
                        <LuMenu size={24}/>
                    </div>
                </div>
                <NaviList
                    className={`${!isHomepageRoot ? "page" : ""}`}
                    $headActive={typeof navigationStore.openIndex === "number"}
                >
                    {/*<MenuNavigationWrapPc />*/}
                    <MenuNavigationWrap type={"pc"}/>
                </NaviList>

            </HeaderWrap>
        </>
    );
})
const HeaderWrap = styled.header`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 40;
    transition: background-color 0.3s ease;
    background-color: ${({$headActive}) => ($headActive ? 'rgba(255, 255, 255, 1)' : 'rgba(0, 0, 0, 0.1)')};
    height: ${({theme}) => theme.SIZE.HEADER.pc};
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid transparent;
    img {
        max-width: 100%;
    }
    .logo {
        flex-shrink: 0;
        width: 200px;
        cursor: pointer;
        position: absolute;
        left: 80px;
        top: 50%;
        transform: translateY(-50%);
        img {
            transition: filter 0.3s ease;
            filter: ${({$headActive}) => $headActive ? "none" : "brightness(0) invert(1)"};
        }
    }
    .back-site{
        display: none;
        cursor: pointer;
    }
    .header-control-wrap{
        position: absolute;
        right: 80px;
        top: 50%;
        transform: translateY(-50%);
        display: flex;
        align-items: center;
        gap: 15px;
        .toggle-btn{
            display: none;
            cursor: pointer;
            svg{
                transition: filter 0.3s ease;
                stroke: ${({$headActive}) => $headActive ? "#000" : "#fff"}
            }
            &.page{
                svg{
                    stroke: #000;
                }
            }
        }
        .mall-to{
            display: flex;
            align-items: center;
            justify-content: center;
            width: 110px;
            height: 38px;
            border-radius: 99px;
            cursor: pointer;
            font-weight: 700;
            font-size: 14px;
            letter-spacing: -0.02em;
            transition: color 0.3s ease, border-color 0.3s ease;
            color: ${({ $headActive }) => ($headActive ? '#4939B1' : '#fff')};
            border: 1px solid ${({ $headActive }) => ($headActive ? '#4939B1' : '#fff')};
        }
    }
    &.page{
        background-color: #fff;
        border-bottom: 1px solid #E6E6E6;
        .logo {
            img{
                filter: none;
            }
        }
        .header-control-wrap{
            .mall-to{
                color: #4939B1;
                border-color: #4939B1;
            }
        }
    }
    &.white{
        background-color: #fff;
        .logo {
            img{
                filter: none;
            }
        }
    }
    @media (max-width: ${SIZES.HEADER}) {
        height: ${({theme}) => theme.SIZE.HEADER.mo};
        padding: 0 25px 0 20px;
        justify-content: space-between;
        &.page{
            border: none;
        }
        .logo {
            width: 108px;
            position: relative;
            left: auto;
            top: auto;transform: translateY(0);
        }
        .header-control-wrap{
            position: relative;
            right: auto;
            top: auto;
            transform: translateY(0);
            .toggle-btn{
                display: block;
            }
            .mall-to{
                font-size: 14px;
                width: 114px;
                height: 28px;
                font-weight: 600;
                line-height: 18px;
                letter-spacing: 0.28px;
                &.page{
                    display: none;
                }
            }
        }
        .back-site{
            display: block;
        }
    }

`;
const NaviList = styled.div`
    height: 100%;
    display: flex;
    align-items: center;
    &.page{
        .menu{
            .list{
                .depth_1{
                    color: #333;
                }
            }
        } 
    }
    .menu{
        .list{
            .depth_1{
                color: ${({$headActive}) => ($headActive ? '#333' : '#fff')};
            }
        }
    }
    @media (max-width: ${SIZES.HEADER}) {
        display: none;
    }
`
export default Header;
